module.exports = __webpack_public_path__ + "img/alert-hexagon.0a5b49a7.svg";